import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, Skeleton, message } from "antd";
import { ReactComponent as Back } from "../../assets/svgs/back-button.svg";
import { API_URLS } from "../../api/apiUrls";
import { getApi } from "../../api/api_instance";
import { QuestionForm } from "./components/questionForm";
import SearchBar from "../../components/Elements/Search/SearchBar";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { QuestionFormScope1234 } from "../QuestionsBank/components/questionFormScope1234";

// const scrollableContainer = {
//   maxHeight: "1000px",
//   overflowY: "auto",
//   padding: "10px",
//   borderRadius: "8px"
// };

const AddQuestions = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [subsections, setSubsections] = useState([]);
  const [selectedSubsection, setSelectedSubsection] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const pageSize = 100;
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);

  const { formId } = useParams();

  useEffect(() => {
    fetchSections();
  }, []);

  useEffect(() => {
    const fetchFormDetails = async () => {
      try {
        
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.GET_STANDARD_FORM_BY_ID(formId)
        });

        if (response?.success && response.data) {
          setFormData(response.data);
        } else {
          message.error("Failed to fetch form details");
        }
      } catch (error) {
        console.error("Error fetching form data:", error);
        message.error("Error fetching form details");
      } finally {
        setLoading(false);
      }
    };

    fetchFormDetails();
  }, [formId]);

  const fetchSections = async () => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.ALL_QUESTIONSPERSECTION(pageSize)
      });
      if (response.success) {
        setSections(response.data);
        if (response.data.length > 0) {
          const firstSection = response.data[0];
          setSelectedSection(firstSection.section);
          fetchSubsections(firstSection.section);
        }
      } else {
        console.error("Failed to fetch sections");
      }
    } catch (error) {
      console.error("Error fetching sections", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubsections = async (sectionId) => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.SUBSECTION_BY_ID(sectionId)
      });
      if (response.success) {
        setSubsections(response.data);
        setSelectedSection(sectionId);

        if (response.data.length > 0) {
          const firstSubsection = response.data[0];
          setSelectedSubsection(firstSubsection.id);
          fetchQuestions(firstSubsection.id);
        }
      } else {
        console.error("Failed to fetch subsections");
      }
    } catch (error) {
      console.error("Error fetching subsections", error);
    } finally {
      setLoading(false);
    }
  };

  const parentCount = Array.isArray(questions) ? questions.reduce((count, group) => {
    if (group.title !== null) {
      return count + 1;
    } else if (group.questions && group.questions.length > 0) {
      return count + 1;
    }
    return count;
  }, 0) : 0;

  const fetchQuestions = useCallback(
    async (subsectionId = selectedSubsection) => {
      if (!subsectionId) return;

      setLoading(true);
      try {
        const response = await getApi({
          apiUrl: API_URLS.QUESTIONS_BY_SUBSECTION(subsectionId, searchTerm)
        });

        if (response.success) {
          console.log("Questions (raw response):", response.data);
           setQuestions(
    Array.isArray(response.data?.divisions)
      ? response.data.divisions
      : []
  );
} else {
  setQuestions([]);
}
      } catch (error) {
        console.error("Error fetching questions", error);
        message.error("Failed to fetch questions");
      } finally {
        setLoading(false);
      }
    },
    [searchTerm]
  );

  useEffect(() => {
    fetchQuestions();
  }, [fetchQuestions]);

  useEffect(() => {
    console.log("Received formId:", formId);
  }, [formId]);

  return (
    <div style={{ backgroundColor: "#fff" }} className="h-full px-[20px] mb-6">
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <TextStyles color="gradient">Standard Form</TextStyles>
        <span>/</span>
        <TextStyles color="gradient">{formData?.title}</TextStyles>
        <span>/</span>
        <TextStyles color="gradient">Add/Modify Questions</TextStyles>
      </div>
      <div className="flex justify-between pb-2">
        <div className="flex items-center">
          <Back className="cursor-pointer" onClick={() => navigate(-1)} />
          <h3 className="text-[#06513D] text-xl">Question Bank</h3>
        </div>
      </div>

      <div className="w-full   shadow-[0_0_16px_0_#3BA2B91F] mb-6">
        <div className="grid grid-cols-5 border border-[#3BA2B959] rounded-t-[10px] overflow-hidden p-1 max-h-[150px] overflow-y-auto">
          {sections.length > 0 ? (
            sections.map((section) => (
              <div
                key={section.id}
                className={`
        relative
        h-10
        py-6
        px-2
        flex
        items-center
        justify-center
        text-[13px]
        font-medium
        cursor-pointer
        rounded-xl
        mx-1
        my-1
        transition-all
        duration-200
        ease-in-out
        border border-[#3BA2B959]
        ${selectedSection === section.section
                    ? "bg-[#06513D] text-white shadow-md transform  scale-105 "
                    : "bg-transparent text-gray-700 hover:text-gray-900"}
        ${selectedSection === section.section ? "" : "hover:shadow-sm"}
      `}
                onClick={() => fetchSubsections(section.section)}
              >
                <span className="text-center leading-tight">
                  {section?.name}
                </span>
              </div>
            ))
          ) : (
            <p className="text-gray-500">No Sections available</p>
          )
          }

        </div>


        {selectedSection && (
          <div>
            <div className="flex flex-wrap gap-5  p-2 text-[11px] font-normal border border-[#3BA2B91C] shadow-[0_0_25.2px_0_#3BA2B91F]">
              {subsections.length > 0 ? (
                subsections.map((sub) => {
                  const isSelected = selectedSubsection === sub.id;

                  return (
                    <div
                      key={sub.id}
                      className={`capitalize p-3 rounded-xl cursor-pointer border transition-all duration-200 
                ${isSelected
                          ? "bg-[#E6EEEC]  shadow-md"
                          : "bg-transparent text-black hover:bg-gray-100"
                        }`}
                      onClick={() => {
                        setSelectedSubsection(sub.id);
                        fetchQuestions(sub.id);
                      }}
                    >
                      {sub.name}
                    </div>
                  );
                })
              ) : (
                <p className="text-gray-500">No subsections available</p>
              )}
            </div>
          </div>
        )}



      </div>

      <div className="w-full border border-[#3BA2B959] rounded-[10px] pt-5 shadow-[0_0_16px_0_#3BA2B91F] mb-6">
        <div className="mt-4 ml-4">
          <div className="flex  gap-4 pl-3">
            <p className="px-8  h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
              TOTAL QUESTIONS: {parentCount}
            </p>
            <SearchBar
              width="300px"
              onSearch={(value) => setSearchTerm(value)}
            />
          </div>
          <div >
            {loading ? (
              <div className="flex flex-col gap-4 p-4">
                <Skeleton.Button block active />
                <Skeleton.Button block active />
                <Skeleton.Button block active />
                <Skeleton.Button block active />
              </div>
            ) : (
              selectedSubsection && (
                <div className="flex justify-center">
                  <div className="shadow-[0_0_16px_0_#3BA2B91F]">
                    {Array.isArray(questions) && questions.length > 0 ? (
                      <QuestionForm
                        formId={formId}
                        sectionId={selectedSection}
                        subSectionId={selectedSubsection}
                        questions={questions}
                        formData={formData}
                      />

                    )

                      : (
                        <p className="text-gray-500 text-center">
                          No questions available.
                        </p>
                      )
                    }
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddQuestions;
